import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import redux from "./store";
import { ParallaxProvider } from 'react-scroll-parallax';

const { store } = redux;
ReactDOM.render(
  <React.StrictMode>
    <ParallaxProvider>
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </ParallaxProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
